<template lang="html">

<article class="slds-card">
  <div class="slds-card__header slds-grid" v-bind:class="{'nospace': nospace}">
    <header class="slds-media slds-media_center slds-has-flexi-truncate">
      <div class="slds-media__figure" v-if="object">
        <span class="slds-icon_container slds-icon-standard-account" v-bind:title="object">
          <svg class="slds-icon slds-icon_small" aria-hidden="true">
            <use v-bind:xlink:href="'/assets/icons/standard-sprite/svg/symbols.svg#'+object"></use>
          </svg>
          <span class="slds-assistive-text">{{object}}</span>
        </span>
      </div>
      <div class="slds-media__body">
        <h2 class="slds-card__header-title">
          <a href="javascript:void(0);" class="slds-card__header-link slds-truncate" v-bind:title="title">
            <span>{{title}}</span>
          </a>
        </h2>
      </div>
      <div class="slds-no-flex">

        <button v-for="action in actions" v-bind:key="action.name" v-on:click.prevent="$emit('click',action.name)" class="slds-button slds-button_neutral slds-button_stateful slds-not-selected" aria-live="assertive">
          <span class="slds-text-not-selected">
            <svg v-if="action.symbol" class="slds-button__icon slds-button__icon_small slds-button__icon_left" aria-hidden="true">
              <use v-bind:xlink:href="'/assets/icons/utility-sprite/svg/symbols.svg#'+action.symbol"></use>
            </svg>
            {{action.name}}
          </span>
        </button>

      </div>
    </header>
  </div>
  <div class="slds-card__body slds-card__body_inner">
    <slot name="body"></slot>
  </div>
  <footer class="slds-card__footer">
    <slot name="footer"></slot>
  </footer>
</article>

</template>

<script>

export default {
  name: 'gnetCard',
  components: {
  },
  computed: {
  },
  props: {
    title: String,
    object: String,
    actions: Array,
    nospace: Boolean
  },
  data() {
    return {
    }
  },
  mounted: function() {
  },
  async created() {

  },
  methods: {
  }
}
</script>

<style scoped>
	.nospace {
		padding: 0rem;
	}
	.mybox {
		padding: 5px;
		border-radius: 0.25rem;
		border: 1px solid #dddbda;
	}

</style>
